module.exports = __webpack_public_path__ + "img/9788958076094.39c0e946.jpg";